<template>
    <div>
        <Tab name="1"></Tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.channelName" placeholder="渠道名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.trackPath" placeholder="跟踪参数" size="small"></el-input>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.selectValue" class="input-with-select" size="small">
                        <el-select v-model="params.selectType" slot="prepend" placeholder="请选择">
                            <el-option label="按渠道" :value="1"></el-option>
                            <el-option label="按跟踪参数" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-date-picker
                        v-model="params.startTime"
                        type="date"
                        placeholder="统计起始日期"
                        value-format="yyyy-MM-dd"
                        size="small"
                        :clearable="false"
                        :editable="false">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-date-picker
                        v-model="params.endTime"
                        type="date"
                        placeholder="统计结束日期"
                        value-format="yyyy-MM-dd"
                        size="small"
                        :clearable="false"
                        :editable="false">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示PV最高的" :value="1"></el-option>
                        <el-option label="优先展示UV最高的" :value="2"></el-option>
                        <el-option label="优先展示注册人数最高的" :value="3"></el-option>
                        <el-option label="优先展示订单数最高的" :value="4"></el-option>
                        <el-option label="优先展示下单人数最高的" :value="5"></el-option>
                        <el-option label="优先展示销售额最高的" :value="6"></el-option>
                        <el-option label="优先展示注册转化率最高的" :value="7"></el-option>
                        <el-option label="优先展示下单转化率最高的" :value="8"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <!-- <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button> -->
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/report/channel/channelReportDownload')" type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="channelName" label="渠道名称" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="trackPath" label="跟踪参数" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="pv" label="PV">
                </el-table-column>
                <el-table-column prop="uv" label="UV">
                </el-table-column>
                <el-table-column prop="registerNum" label="注册人数">
                </el-table-column>
                <el-table-column prop="orderNum" label="订单数">
                </el-table-column>
                <el-table-column prop="orderUser" label="下单人数">
                </el-table-column>
                <el-table-column prop="orderAmount" label="销售额">
                </el-table-column>
                <el-table-column prop="registerCr" label="注册转化率">
                    <template slot-scope="scope">
                        {{(scope.row.registerCr * 100).toFixed(1)}}%
                    </template>
                </el-table-column>
                <el-table-column prop="orderCr" label="下单转化率">
                    <template slot-scope="scope">
                        {{(scope.row.orderCr * 100).toFixed(1)}}%
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/report/channel/channelDataList')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >跟踪对象明细</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import Tab from "../components/tab"
import {downloadFileTmp} from '@/assets/js/commonApi';
const defaultParams = {
    pageNo:1,
    trackPath:"",
    channelName:"",
    startTime:"",
    endTime:"",
    sort:1,

    selectType: 1,
    selectValue: ''
}
export default {
    components:{Tab},
    data(){
        const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' );
        const startTime = this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 90), 'yyyy-MM-dd' );
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                trackPath: this.$route.query.trackPath || "",
                channelName: this.$route.query.channelName || '',
                startTime:this.$route.query.startTime || startTime,
                endTime:this.$route.query.endTime || endTime,
                sort:parseInt(this.$route.query.sort || 1),

                selectType: parseInt(this.$route.query.selectType || 1),
                selectValue: this.$route.query.selectValue || "",
            },
            listLoading: true,
            downLoading: false
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            const _timeRang = new Date( this.params.endTime ) - new Date( this.params.startTime );
            const _yearRang = parseInt(_timeRang / 24 / 3600 / 1000);
            if( _yearRang > 730 ){
                this.$message.error('目前仅支持最多2年的数据');
                return;
            }    
            this.listLoading = true;
            this.params = {
                ...this.params,
                channelName: this.params.selectType == 1 ? this.params.selectValue : '',
                trackPath: this.params.selectType == 2 ? this.params.selectValue : '',
                startTime: this.params.startTime + ' 23:59:59',
                endTime: this.params.endTime + ' 00:00:00',
            }
            this.$request({
                url: "/report/channel/channelReportList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/report/channel/channelReportDownload',
                method: 'post',
                data: {
                    ...this.params,
                    // startTime: this.params.startTime + ' 23:59:59',
                    // endTime: this.params.endTime + ' 00:00:00',
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'渠道数据汇总.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //跟踪对象明细
        view(item){
            this.$router.push({
                path: `/report/channel/channelReport/channelDataList/${item.id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                    ...this.params,
                },
            });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>